var TemplateValidation = (function () {
    function TemplateValidation() {
    }
    TemplateValidation.prototype.run = function (fc) {
        fc.templateManipulators.postWrapper.push(function (field) {
            if (field && field.validators) {
                return 'validation-message';
            }
        });
    };
    return TemplateValidation;
}());
export { TemplateValidation };
//# sourceMappingURL=validation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/run/validation.js
// module id = 771
// module chunks = 3